import React, { useState } from 'react';
import Button from '../../Form/Button';
import Modal from '../Modal';
import FormConfirmMobilePhone from './FormConfirmMobilePhone';
import ButtonClose from '../../Form/ButtonClose';
import { MdVerified } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

interface ConfirmMobilePhoneProps {
    phone: string;
    confirmed: boolean;
    className?: string;
    onSuccess: CallableFunction;
}

const ConfirmMobilePhone = ({ phone, confirmed, className, onSuccess }: ConfirmMobilePhoneProps) => {

    const { t } = useTranslation();
    const [ showConfirm, setShowConfirm ] = useState<boolean>(false);

    const handleSuccess = () => {
        setShowConfirm(false);
        onSuccess();
    }

    if (!phone) return null;

    return (
            <>
                <div className={`flex items-center ${className}`}>
                    {confirmed ?
                        <>
                            <MdVerified className='text-shopfood-success text-sm' />
                            <span className='text-xs leading-none text-nowrap text-gray-400 mr-1 italic font-medium'>{t('profile.basic_info.mobile_phone.verified_label')}</span>
                        </>
                        :   <Button onClick={() => setShowConfirm(true)} className='h-7 text-sm md:w-full gap-1'>{t('profile.basic_info.mobile_phone.button_verify_label')}</Button>
                    }
                </div>
                <Modal open={showConfirm} className="relative max-w-sm m-4" onClose={() => setShowConfirm(false)} closeable={false}>
                    <ButtonClose fixedOnTop onClick={() => setShowConfirm(false)} />
                    <FormConfirmMobilePhone phone={phone} onSuccess={handleSuccess} />
                </Modal>
            </>
        )
    }

export default ConfirmMobilePhone;